import Loader from "react-loader-spinner";
import { faCalendarDay, faListUl, faReceipt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row, Table } from 'react-bootstrap';
import { getChequesWithCloseDueDateList, getDraftDocuments } from "../store/api/DocumentsAPI";
import { useHistory } from "react-router-dom";
import { isWebApp } from "../../store/api/CommonFunctions";
const HomePage = () => {
    const history = useHistory();
    const [draftDocs, getDraftDocs] = useState([]);
    const [cheques, getCheques] = useState([]);
    useEffect(() => {
        document.body.classList = "mainPage";
        getDraftDocuments("", getDraftDocs);
        getChequesWithCloseDueDateList(getCheques);
    }, []);
    const goToSearchDocuments = useCallback(() => {
        history.push("/Accounting/SearchDocuments");
    })
    function gotoSearchCheques(){
        history.push("/Accounting/SearchCheques");
    }
    return (
        <div>
            <img style={{ marginTop: "10px", marginBottom: "10px" }} alt="" />
            <div className="container-fluid mt-3">
                <Row className='g-4'>
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "#4c3ac4", "--footerColor": "#dc669e", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">
                                    <FontAwesomeIcon icon={faListUl} size="lg" color="white" onClick={() => getChequesWithCloseDueDateList(getCheques)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {cheques === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {Array.isArray(cheques?.Data??"") &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#dee9fa91" }}>
                                            <thead style={{ background: "#5c79d4", color: "whitesmoke" }}>
                                                <tr>
                                                    <th>{isWebApp() ? "شماره چک" : "چک"}</th>
                                                    <th>{isWebApp() ? "تاریخ سررسید" : "سررسید"}</th>
                                                    <th>{isWebApp() ? "نام بانک و شعبه" : "بانک"}</th>
                                                    <th>{isWebApp() ? "شماره حساب جاری" : "حساب جاری"}</th>
                                                    <th>مبلغ چک</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {cheques.Data.map((row, i) =>
                                                    <tr style={{ color: row.Color }} key={i} >
                                                        <td>{row.ChequeNumber}</td>
                                                        <td>{row.PDueDate}</td>
                                                        <td>{row.BankName}</td>
                                                        <td>{row.BankAccountNo}</td>
                                                        <td>{Number(row.ChequeAmount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faCalendarDay} size="lg" color="white" style={{ cursor: "pointer" }} onClick={gotoSearchCheques}/>
                                &nbsp;
                                سررسید چک ها
                            </Card.Footer>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="saleCards" style={{ "--mainColor": "#bc3ac4", "--footerColor": "#728ee8", height: "310px" }}>
                            <Card.Header style={{ color: "black", border: "none", padding: "5px" }}>
                                <div className="go-corner">
                                    <FontAwesomeIcon icon={faListUl} size="lg" color="white" onClick={() => getDraftDocuments("", getDraftDocs)} />
                                    &nbsp;&nbsp;
                                </div>
                            </Card.Header>

                            <Card.Body>
                                {draftDocs === "PENDING" && <Loader type="BallTriangle" width={30} height={30} className="loader" />}
                                {draftDocs && Array.isArray(draftDocs) &&
                                    <div style={{ maxHeight: "220px", overflowY: "auto" }} className="hideScroll">
                                        <Table className="designedTable" style={{ "--rowColor": "#f9defa91" }}>
                                            <thead style={{ background: "#b86cb4", color: "whitesmoke" }}>
                                                <tr>
                                                    <th>شماره سند</th>
                                                    <th>تاریخ سند</th>
                                                    <th>شرح سند</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "right", borderTop: "1px solid gray" }}>
                                                {draftDocs.map((row, i) =>
                                                    <tr key={i} onClick={() => history.push(`/Accounting/AddEditDocument/${row.DocID}`)}>
                                                        <td>{row.DocNumber}</td>
                                                        <td>{row.DocDate}</td>
                                                        <td>{row.DocDesc}</td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Card.Body>
                            <Card.Footer style={{ color: "whitesmoke" }} >
                                <FontAwesomeIcon icon={faReceipt} size="lg" color="white" style={{ cursor: "pointer" }} onClick={goToSearchDocuments} />
                                &nbsp;
                                سندهای پیش نویس
                            </Card.Footer>

                        </Card>
                    </Col>
                </Row>
            </div>
        </div>

    )

}

export default HomePage;